<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-data-table :headers="headers" :items="payment_type_list" sort-by="calories" dense class="elevation-1 mytable"
            :search="search">
            <template v-slot:top>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Payment Type </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row dense justify="center">
                    <v-col sm="3" md="3" cols="12"> </v-col>
                    <v-col sm="6" md="6" cols="12">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line
                            hide-details></v-text-field>
                    </v-col>
                    <v-col sm="3" md="3" cols="12">
                        <span style="width: 20px;"> </span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn small class="mb-2 button" v-on="on">Add Payment Type</v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="toolbar">
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="10" md="10">
                                                <v-text-field v-model.trim="editedItem.payment_type" persistent-hint
                                                    :hint="editedIndex == -1 ? 'For example :: MISC,TRANSPORT,OUTSTANDING..' : 'noneditable'"
                                                    :filled="editedIndex == -1 ? false : true"
                                                    :disabled="editedIndex != -1" label="Payment Type"
                                                    :error="errorMsg.employeeType ? true : false"
                                                    :error-messages="errorMsg.employeeType ? 'Required' : ''">
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2" md="2">
                                                <v-checkbox dense v-model="editedItem.isforquickpay" color="success"
                                                    label="Active"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="button" @click="close">Cancel</v-btn>
                                    <v-btn class="button" @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.isforquickpay="{ item }">
                <span v-if="item.isforquickpay">
                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
            </template>

            <template v-slot:item.action="{ item }">

                <div>
                    <v-avatar style="" size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)">
                            edit
                        </v-icon>
                    </v-avatar>
                </div>
            </template>

        </v-data-table>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {

    components: {
        Breadcrumbs,
    },

    data: () => ({
        errorMsg: {
            payment_type: false,
        },
        search: "",

        // extraBreadcrumbItems: [
        //     { text: "Payment Type", disabled: true, href: "" },

        // ],
        breadcrumbClass: "breadcrumb-style1",
        snackbar_msg: "",
        color: "",
        snackbar: false,

        dialog: false,
        headers: [
            {
                text: "Payment Type",
                align: "left",
                sortable: true,
                value: "payment_type",
            },
            { text: "Is For Quick Pay", value: "isforquickpay", sortable: false },
            { text: "Actions", value: "action", sortable: false },

        ],
        payment_type_list: [],
        editedIndex: -1,
        editedItem: {
            payment_type: "",
            isforquickpay: false,

        },
        defaultItem: {
            payment_type: "",
            isforquickpay: false,

        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Payment Type" : "Edit Payment Type";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    mounted() {
        axios
            .post("/AccountingAndFees/paymentTypeHome")
            .then((res) => {
                if (res.data.msg == "200") {
                    this.payment_type_list = res.data.payment_type_list;
                    this.load = true;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
            })
            .catch((error) => {
                window.console.log(error);
            });
    },
    methods: {
        initializeErrorMsgFalse() {
            this.errorMsg.employeeType = false;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        editItem(item) {
            this.editedIndex = this.payment_type_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        close() {
            this.initializeErrorMsgFalse();
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/AccountingAndFees/editPaymentType", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                Object.assign(this.payment_type_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Payment Type Updated Successfully..."); // show snackbar on succes
                            } else {
                                this.showSnackbar("red", res.data.snackbar);
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                if (this.isValidated()) {
                    axios
                        .post("/AccountingAndFees/savePaymentType", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.payment_type_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Payment Type Added Successfully..."); // show snackbar on succes
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Payment Type Already Present!!!"); // show snackbar on error
                            } else {
                                this.showSnackbar("red", res.data.snackbar);
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            }
        }, // end of save()

        isValidated() {
            // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
            if (this.editedItem.payment_type) {
                return true;
            } else {
                if (!this.editedItem.payment_type) {
                    this.errorMsg.payment_type = true;
                }

                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
